/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EAFSGAreaDTO
 */
export interface EAFSGAreaDTO {
    /**
     * 
     * @type {string}
     * @memberof EAFSGAreaDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof EAFSGAreaDTO
     */
    readonly name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EAFSGAreaDTO
     */
    readonly description?: string | null;
}

export function EAFSGAreaDTOFromJSON(json: any): EAFSGAreaDTO {
    return EAFSGAreaDTOFromJSONTyped(json, false);
}

export function EAFSGAreaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EAFSGAreaDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function EAFSGAreaDTOToJSON(value?: EAFSGAreaDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

